var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"history"},[_c('div',{staticClass:"history-menu"},[_c('MenuRaffleResults')],1),(!_vm.shouldShowActivePromotions)?_c('div',{staticClass:"history-content"},[_c('RaffleResults')],1):_vm._e(),(_vm.shouldShowActivePromotions)?_c('div',{staticClass:"history-content"},[_c('Promotion')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }